import { render, staticRenderFns } from "./CommonCodeMng.vue?vue&type=template&id=b67964e0"
import script from "./CommonCodeMng.vue?vue&type=script&lang=js"
export * from "./CommonCodeMng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b67964e0')) {
      api.createRecord('b67964e0', component.options)
    } else {
      api.reload('b67964e0', component.options)
    }
    module.hot.accept("./CommonCodeMng.vue?vue&type=template&id=b67964e0", function () {
      api.rerender('b67964e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/cp/CommonCodeMng.vue"
export default component.exports